import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  dialog: {
    maxWidth: 850,
    textAlign: "center",
  },
  dialogActions: {
    justifyContent: "space-around",
    padding: "20px",
  },
  title: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default useStyles;
